import React, { useRef, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
// import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  IconButton,
  TextField,
  Typography,
  Badge,
  Grid,
  Tooltip,
  Skeleton
} from "@mui/material";

import DialogModal from "./DialogModal";
import useStyle from "./Suppot.style";
import {
  ACCEPTED_IMAGE_FORMATS,
  MAX_IMAGE_FILE_SIZE_SUPPORT
} from "../../utils/constants";
import { showErrorMessage } from "../../redux-saga/redux/toast";
import { createMessage } from "../../redux-saga/redux/support/chatsupport";
import { compareInString } from "../SportsBookNode/utils/common/functions";

const MessageSupport = ({ updatedData, ticketid }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [input, setInput] = useState("");

  const { subjectlist, messageloading, messagedetails, ticketStatus } =
    useSelector((state) => state.supportmodal);
  const [open, setOpen] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const [adminname, setAdminname] = useState("");
  const [chatImage, setChatImage] = useState();
  const [supportImage, setSupportImage] = useState({
    selectedImage: null,
    selectedImageName: "",
    avatar: null
  });

  const lastMessageData = messagedetails[messagedetails?.length - 1];

  const classes = useStyle();

  const messageContainerRef = useRef(null);

  const scrollToEnd = () => {
    if (messageContainerRef?.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef?.current?.scrollHeight;
    }
  };

  const scrollToStart = () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = 0;
    }
  };

  useEffect(() => {
    if (updatedData && updatedData.length > 0) {
      scrollToEnd();
      if (updatedData?.[updatedData.length - 1]?.agent_name)
        setAdminname(updatedData?.[updatedData.length - 1]?.agent_name);
    }
  }, [updatedData]);

  useEffect(() => {
    scrollToStart();
  }, [messagedetails, ticketStatus]);

  const resetSelectedImage = () => {
    setSupportImage({
      selectedImage: null,
      selectedImageName: "",
      avatar: null
    });
  };

  const handleFileInputChange = (event) => {
    event.preventDefault();
    const file = event.target.files && event.target.files[0];
    if (!file) {
      resetSelectedImage(event);
      return;
    }

    if (file?.size > MAX_IMAGE_FILE_SIZE_SUPPORT) {
      toast.error(t("MYPROFILE.MAX_FILE_SIZE_ERROR_2MB"), {
        id: "MAX_FILE_SIZE_ERROR"
      });
      return;
    }

    setSupportImage((current) => ({
      selectedImage: file,
      avatar: current.avatar,
      selectedImageName: file?.name || ""
    }));
  };

  const makeAvatarUrl = () => {
    if (supportImage.selectedImage) {
      return URL.createObjectURL(supportImage.selectedImage);
    }
    return "/images/user_icon.svg";
  };

  const handleClickOpen = (imageUrl) => {
    setChatImage(imageUrl);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendInputMessage = () => {
    const formData = new FormData();

    if (input === "" && !supportImage.selectedImage) {
      dispatch(showErrorMessage({ msg: "message is empty" }));
    } else {
      if (supportImage.selectedImage) {
        formData.append("attachment", supportImage.selectedImage);
      }
      formData.append("ticketId", ticketid);
      formData.append("message", input.trim());

      dispatch(createMessage(formData));
      setInput("");
    }
  };

  const handleInputMessage = (e) => {
    if (e.target.value !== " ") {
      setInput(e.target.value);
    }
  };

  return (
    <div className={classes.chatWrap}>
      {" "}
      {subjectlist?.count == 0 && (
        <span>{t("SUPPORT_MODAL.TICKETS_NOT_FOUND")}</span>
      )}
      <span className={classes.subjectWrap}>
        {messagedetails?.[0]?.ticket} <br />{" "}
        {t("SUPPORT_MODAL.CUSTOMER_SERVICE")}
      </span>
      {messageloading ? (
        <div className={classes.loaderWrap}>
          <Skeleton
            variant="rectangular"
            height={380}
            className={classes.circularprogress}
          />
        </div>
      ) : (
        <div
          className={`${
            supportImage.selectedImage
              ? classes.sendMessage
              : classes.chatScroll
          }`}
          ref={messageContainerRef}
        >
          {updatedData?.map((message) => {
            return (
              <div key={message?.id}>
                {message?.user_name || message?.owner_type === "User" ? (
                  <>
                    <p className={classes.username1}>
                      <span className={classes.textMessageUser1}>
                        {message?.file_path && (
                          <DialogModal
                            handleClickOpen={handleClickOpen}
                            handleClose={handleClose}
                            open={open}
                            message={message}
                            chatImage={chatImage}
                          />
                        )}
                        {message?.message}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <p className={classes.username2}>
                      <span className={classes.textMessageUser2}>
                        {message?.file_path && (
                          <DialogModal
                            handleClickOpen={handleClickOpen}
                            handleClose={handleClose}
                            open={open}
                            message={message}
                            chatImage={chatImage}
                          />
                        )}

                        {message?.message}
                      </span>
                    </p>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
      {compareInString(lastMessageData?.ticket_status, 0) ? (
        <>
          {!ticketStatus && (
            <Box
              className={`${classes.chatSendBox} ${
                supportImage.selectedImage ? classes.sendIconPosition : ""
              }`}
            >
              <TextField
                id="standard-basic"
                variant="standard"
                placeholder={t("SUPPORT_MODAL.MESSAGE")}
                value={input}
                onChange={handleInputMessage}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    sendInputMessage();
                    resetSelectedImage();
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <Grid className={classes.msgInputCta}>
                      <Badge
                        className={
                          supportImage.selectedImage
                            ? classes.attachmentBadge
                            : ""
                        }
                        badgeContent={
                          supportImage.selectedImage ? (
                            <IconButton onClick={resetSelectedImage}>
                              <CancelIcon />
                            </IconButton>
                          ) : null
                        }
                      >
                        <Tooltip
                          classes={{
                            tooltip: classes.toolTipWrap,
                            arrow: classes.toolTipArrow
                          }}
                          title={
                            supportImage.selectedImage
                              ? t("SUPPORT_MODAL.CHANGE_IMAGE")
                              : t("SUPPORT_MODAL.UPLOAD_IMAGE")
                          }
                          arrow
                        >
                          <IconButton
                            className={classes.textFieldEndIconBtn}
                            disabled={messageloading}
                            variant="contained"
                            component="label"
                          >
                            <input
                              key={supportImage.selectedImageName}
                              onChange={handleFileInputChange}
                              type="file"
                              hidden
                              accept={ACCEPTED_IMAGE_FORMATS.join(",")}
                            />
                            {supportImage.selectedImage ? (
                              <div className={classes.selectedImgWrap}>
                                <img
                                  height="30"
                                  width="30"
                                  alt=""
                                  src={makeAvatarUrl()}
                                />
                                <Typography className={classes.selectedImgName}>
                                  {supportImage.selectedImageName}
                                </Typography>
                              </div>
                            ) : (
                              <AttachmentIcon />
                            )}
                          </IconButton>
                        </Tooltip>
                      </Badge>
                    </Grid>
                  )
                }}
              />

              <div
                role="button"
                tabIndex={0}
                onClick={() => {
                  sendInputMessage();
                  resetSelectedImage();
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    sendInputMessage();
                    resetSelectedImage();
                  }
                }}
              >
                <img
                  src="/images/sportsbook/🦆 sendIcon.svg"
                  alt="Send Icon"
                  className={classes.sendIcon}
                  style={{ pointerEvents: "auto" }}
                />
              </div>

              {/* <SendIcon
          className={classes.sendIcon}
          onClick={() => {
            sendInputMessage();
            resetSelectedImage();
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              sendInputMessage();
              resetSelectedImage();
            }
          }}
          role="button"
          tabIndex={0}
        ></SendIcon> */}
            </Box>
          )}
          {ticketStatus && (
            <Typography className={classes.chatEnded}>
              {t("SUPPORT_MODAL.CONVERSATION_ENDED_MESSAGE")}
            </Typography>
          )}
        </>
      ) : (
        <>
          {lastMessageData?.ticket_status && (
            <Typography className={classes.chatEnded}>
              {t("SUPPORT_MODAL.CONVERSATION_ENDED_MESSAGE")}
            </Typography>
          )}
        </>
      )}
    </div>
  );
};

export default MessageSupport;
